module.exports = __webpack_public_path__ + "img/arr.fe88b6a4.svg";